import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-84927a90")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock(_component_el_select, {
    placeholder: "",
    onRemoveTag: _ctx.removeTagHandler
  }, _createSlots({
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item[_ctx.valueKey],
          label: item[_ctx.labelKey],
          value: item[_ctx.valueKey],
          disabled: item.disabled
        }, null, 8, ["label", "value", "disabled"]))
      }), 128))
    ]),
    _: 2
  }, [
    (_ctx.$slots.prefix)
      ? {
          name: "prefix",
          fn: _withId(() => [
            _renderSlot(_ctx.$slots, "prefix")
          ])
        }
      : undefined
  ]), 1032, ["onRemoveTag"]))
})